<template>
    <div>
    <div  >
    </div>
    <div class="video-container">
        <video ref="videoRef" muted loop playsinline autoplay class="background-video" poster="/videos/free-ice-poster.webp">
            <source src="/videos/free-ice.mp4" type="video/mp4">
            <source src="/videos/free-ice.ogg" type="video/ogg">
            Váš prohlížeč nepodporuje video tag.
        </video>
        
        <div class="content-overlay" ref="overlay" :style="{ overflowY: pageScrollLock ? 'auto' : 'hidden' }">
            <div class="partner title mb-12 pt-12" ref="titleRef">Trenéři</div>
            <v-container max-width="1200">
                <v-row>
                    <v-col cols="12" sm="4" xl="3">
                        <v-img src="/img/stuff/tomas-tuma/tomas-tuma_large.webp" width="100%"></v-img>
                        <v-card class="mh-blue-blur-card">
                            <v-card-title>Tomáš Tůma</v-card-title>
                            <v-card-text>
                                <div class="trener-title"><strong>Majitel a skills coach</strong>,</div>
                                <div>bývalý profesionální hráč, nyní trenér mládeže ve Vyškově.</div>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="4" xl="3">
                        <v-img src="/img/stuff/jiri-otoupalik/jiri-otoupalik_large.webp" width="100%"></v-img>
                        <v-card class="mh-blue-blur-card">
                            <v-card-title>Jiří Otoupalík</v-card-title>
                            <v-card-text>
                                <div class="trener-title"><strong>Hlavní trenér</strong>,</div>
                                <div>bývalý profesionální hráč, momentálně trenér mužů v Blansku.</div>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="4" xl="3">
                        <v-img src="/img/stuff/radek-husak/radek-husak_large.webp" width="100%"></v-img>
                        <v-card class="mh-blue-blur-card">
                            <v-card-title>Radek Husák</v-card-title>
                            <v-card-text>
                                <div class="trener-title"><strong>Trenér</strong>,</div>
                                <div>bývalý hráč do mládežnických kategorií, nyní trenér mládeže v HCM Warriors Brno a
                                    ženského týmu Valkyries Brno.</div>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="4" xl="3">
                        <v-img src="/img/stuff/eliska-liskova/eliska-liskova_large.webp" width="100%"></v-img>
                        <v-card class="mh-blue-blur-card">
                            <v-card-title>Eliška Lísková</v-card-title>
                            <v-card-text>
                                <div class="trener-title"><strong>Trenérka bruslení</strong>,</div>
                                <div>bývalá krasobruslařka, v současnosti trenérka mládeže v HCM Warriors Brno.</div>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="4" xl="3">
                        <v-img src="/img/stuff/dummy/dummy_large.webp" width="100%"></v-img>
                        <v-card class="mh-blue-blur-card">
                            <v-card-title>Jiří Sýkora</v-card-title>
                            <v-card-text>
                                <div class="trener-title"><strong>Trenér</strong>,</div>
                                <div>současně trenér juniorů v HCM Warriors Brno.</div>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="4" xl="3">
                        <v-img src="/img/stuff/milan-vodicka/milan-vodicka_large.webp" width="100%"></v-img>
                        <v-card class="mh-blue-blur-card">
                            <v-card-title>Milan Vodička</v-card-title>
                            <v-card-text>
                                <div class="trener-title"><strong>Trenér brankářů</strong>,</div>
                                <div>bývalý profesionální brankář, nyní hráčský agent.</div>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="4" xl="3">
                        <v-img src="/img/stuff/marek-bartos/marek-bartos_large.webp" width="100%"></v-img>
                        <v-card class="mh-blue-blur-card">
                            <v-card-title>Marek Bartoš</v-card-title>
                            <v-card-text>
                                <div class="trener-title"><strong>Trenér</strong>,</div>
                                <div>aktivní hráč univerzitní ligy.</div>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="4" xl="3">
                        <v-img src="/img/stuff/katerina-prokesova/katerina-prokesova_large.webp" width="100%"></v-img>
                        <v-card class="mh-blue-blur-card">
                            <v-card-title>Kateřina Prokešová</v-card-title>
                            <v-card-text>
                                <div class="trener-title"><strong>Obsluha časomíry, kustod</strong>,</div>
                                <div>bývalá krasobruslařka, v současnosti zapisovatelka v profesionálních soutěžích.</div>
                            </v-card-text>
                        </v-card>
                    </v-col>

                    <v-col cols="12" sm="4" xl="3">
                        <v-img src="/img/stuff/michal-komornik/michal-komornik_large.webp" width="100%"></v-img>
                        <v-card class="mh-blue-blur-card">
                            <v-card-title>Michal Komorník</v-card-title>
                            <v-card-text>
                                <div class="trener-title"><strong>Kondiční trenér</strong>,</div>
                                <div>absolvent trenérství na Masarykově univerzitě, osobní trenér v TCB.</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <!-- Debug okno ve spodním pravém rohu -->
         <!--
        <div class="debug-window">{{ titlePosition }} {{ pageScrollLock }}</div>
        -->
    </div>
</div>
</template>

<script setup lang="ts">
import { onMounted, ref, onUnmounted } from 'vue';



const overlay = ref<HTMLElement | null>(null);
const videoRef = ref<HTMLVideoElement | null>(null);
const titleRef = ref<HTMLElement | null>(null);
const titlePosition = ref<{ x: number; y: number }>({ x: 0, y: 0 });
const pageScrollLock = ref(false);
const animationFrameId = ref<number | null>(null);

const updateTitlePosition = () => {
    if (titleRef.value) {
        const rect = titleRef.value.getBoundingClientRect();
        titlePosition.value = { x: Math.round(rect.left), y: Math.round(rect.top) };

        // Pokud je titleRef pod 60px, nastav pageScrollLock na true
        pageScrollLock.value = rect.top <= 60;
    }
    animationFrameId.value = requestAnimationFrame(updateTitlePosition);
};

onMounted(() => {

    updateTitlePosition();
});

onUnmounted(() => {
    if (animationFrameId.value !== null) {
        cancelAnimationFrame(animationFrameId.value);
    }
});
</script>

<style scoped>
.video-container {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100vh;
}

.background-video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.content-overlay {
    position: relative;
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 1rem;
    color: white;
    height: 100vh;
    justify-content: flex-start;
}

.mh-blue-blur-card {
    backdrop-filter: blur(5px) !important;
    background-color: rgba(35, 45, 70, 0.5) !important;
    -webkit-backdrop-filter: blur(5px);
    color: white;
    border-radius: 10px;
}

.partner.title {
    color: white;
}

.debug-window {
    position: fixed;
    top: 100px;
    right: 20px;
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 10px;
    border-radius: 5px;
    font-size: 14px;
}
</style>